<section class="container">
    <mat-card>
        <mat-card-title class="mat-title">Unified Digital Message Portal</mat-card-title>
        <mat-card-subtitle>Please login to manage UDM integrations.</mat-card-subtitle>
        <mat-card-footer class="mat-caption">&copy; {{ today.getFullYear() }} Upstream Works All Rights Reserved.</mat-card-footer>
        <mat-card-content>
          <form [formGroup]="loginForm" (ngSubmit)="submit(loginForm.value)">
            <mat-form-field appearance="standard">
              <mat-label>App ID</mat-label>
              <input type="text" formControlName="appId" placeholder="App ID" matInput required />
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>API Key ID</mat-label>
              <input type="text" formControlName="keyId" placeholder="API Key ID" matInput required />
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>API Key Secret</mat-label>
              <input type="password" formControlName="secret" placeholder="API Key Secret" matInput required />
            </mat-form-field>
            <mat-form-field appearance="standard">
              <mat-label>Region</mat-label>
              <mat-select [(value)]="selectedRegion" formControlName="region">
                <mat-option [value]="region" *ngFor="let region of regions">{{ region.name }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button type="submit" mat-flat-button color="primary" [disabled]="!loginForm.valid">Login</button>
            <pre *ngIf="error">{{ error }}</pre>
          </form>
        </mat-card-content>
    </mat-card>
</section>
